module.exports = __webpack_public_path__ + "img/insta-3.d722383b.jpg";